var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup262(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(-49 -3076)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(49 3076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M43.911,17.141A10.792,10.792,0,0,0,54.8,6.252V5.733a8.429,8.429,0,0,0,1.867-1.97,8.609,8.609,0,0,1-2.178.622,4.035,4.035,0,0,0,1.659-2.074,9.512,9.512,0,0,1-2.385.933A3.7,3.7,0,0,0,50.963,2a3.9,3.9,0,0,0-3.837,3.837,2.022,2.022,0,0,0,.1.83,10.722,10.722,0,0,1-7.881-4.044,3.971,3.971,0,0,0-.519,1.97,4.12,4.12,0,0,0,1.659,3.215,3.5,3.5,0,0,1-1.763-.519h0a3.79,3.79,0,0,0,3.111,3.733,3.2,3.2,0,0,1-1.037.1,1.765,1.765,0,0,1-.726-.1,3.929,3.929,0,0,0,3.63,2.7,7.83,7.83,0,0,1-4.77,1.659,2.871,2.871,0,0,1-.933-.1,9.788,9.788,0,0,0,5.911,1.867",
    transform: "translate(17.967 3082.93)",
    fill: "#123374",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup262);
export default __webpack_public_path__ + "static/media/Group 262.47938a94a23feca2a3537c31e393ba82.svg";
export { ForwardRef as ReactComponent };